import { type CoreBooking } from '@flecto/types'
import { DataTable, type DataTableProps } from '@flecto/ui'

import { useColumns } from './useColumns'

type TableBookingsProps = Omit<DataTableProps<CoreBooking>, 'columns'> & {
  bookings?: CoreBooking[]
  isLoading?: boolean
}

export function TableBookings({
  bookings,
  isLoading,
  ...props
}: TableBookingsProps) {
  const columns = useColumns()

  return (
    <DataTable
      {...props}
      records={bookings}
      columns={columns}
      isLoading={isLoading}
      highlightOnHover
    />
  )
}
